import immutableStore from 'alt-utils/lib/ImmutableUtil';
import alt from 'components/Dispatcher';
import TeamActions from 'actions/TeamActions';
import {Record, List} from 'immutable';
import AdminFormDataActions from 'actions/admin/AdminFormDataActions';
import AuthStore from 'stores/AuthStore';
import AdminFormDataSource from 'sources/admin/AdminFormDataSource';

const State = Record({
  departments: null,
  // A list of teams returned from the server-side
  teams: null,
  // A list of integrations returned from the server-side
  integrations: null,
  managers: null,
  // True if the form data is being loaded
  formDataLoading: true,
  // true if form submit loading
  formDataSuccess: false,
  // true if the form submit succeeded
  formDataFailed: false,
});

/**
 * Stores the state of Admin User forms
 */
@immutableStore
class AdminFormDataStore {
  constructor() {
    this.state = State();
    this.bindActions(TeamActions);
    this.bindActions(AdminFormDataActions);
    this.registerAsync(AdminFormDataSource);
  }

  onAddNewTeam(name) {
    const newTeamObj = {id: 'NEW_TEAM_ID', name: name};

    let teams = this.state.get('teams');
    teams = teams.filter(team => team.id !== 'NEW_TEAM_ID');
    teams = teams.push(newTeamObj);

    this.setState(this.state.set('teams', teams));
  }

  updateTeamSuccess() {
    this.onFetchFormData();
  }

  createTeamSuccess() {
    this.onFetchFormData();
  }

  /**
   * Get the user form data
   */
  onFetchFormData(args) {
    // get logged user account
    const {accountId} = AuthStore.getState().user;

    this.setState(
      this.state
        .set('formDataLoading', true)
        .set('formDataSuccess', false)
        .set('formDataFailed', false)
    );

    this.getInstance().fetchFormData(accountId, args);
  }

  /**
   * Update this.state
   * @param {object} resp A server-side response
   */
  onFetchFormDataSuccess(resp) {
    this.setState(
      this.state
        .set('teams', List(resp.data['teams']))
        .set('integrations', List(resp.data['integrations']))
        .set('managers', List(resp.data['managers'].user_list))
        .set('departments', List(resp.data['departments']))
        .set('formDataLoading', false)
        .set('formDataFailed', false)
    );
    setImmediate(AdminFormDataActions.formDataUpdated);
  }
}

export default alt.createStore(AdminFormDataStore, 'AdminFormDataStore');
